import { useState } from "react";
import { authApi } from "../../services/apiClient";
import { APP_FONT_FAMILY } from "../../shared/theme";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const goLogin = () => {
    const path = window.location.pathname || "/";
    window.location.href = path;
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");
    try {
      const data = await authApi.forgotPassword(email.trim());
      setMessage(data?.message || "Demande enregistree.");
    } catch (err) {
      setError(err.message || "Demande impossible.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f9fafb",
        fontFamily: APP_FONT_FAMILY,
        padding: 20,
      }}
    >
      <form
        onSubmit={submit}
        style={{
          width: "100%",
          maxWidth: 420,
          background: "#fff",
          borderRadius: 12,
          padding: 28,
          border: "1px solid #e4e7ec",
          boxShadow: "0 1px 3px rgba(16,24,40,0.08)",
        }}
      >
        <h1 style={{ margin: 0, fontSize: 22, color: "#111827" }}>Mot de passe oublié</h1>
        <p style={{ marginTop: 8, marginBottom: 20, color: "#6b7280", fontSize: 13 }}>
          Saisissez l&apos;email de votre compte. Si celui-ci existe, vous recevrez un lien pour choisir un nouveau mot de passe.
        </p>

        <label style={{ display: "block", fontSize: 12, color: "#374151", marginBottom: 6 }}>Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #d1d5db", marginBottom: 14 }}
        />

        {error && (
          <div style={{ marginBottom: 12, padding: "10px 12px", background: "#fef2f2", color: "#991b1b", border: "1px solid #fecaca", borderRadius: 8, fontSize: 12 }}>
            {error}
          </div>
        )}

        {message && (
          <div style={{ marginBottom: 12, padding: "10px 12px", background: "#ecfdf3", color: "#065f46", border: "1px solid #bbf7d0", borderRadius: 8, fontSize: 12, lineHeight: 1.5 }}>
            {message}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: "11px 12px",
            borderRadius: 8,
            border: "none",
            background: "#2563eb",
            color: "#fff",
            fontWeight: 700,
            cursor: "pointer",
            opacity: loading ? 0.7 : 1,
            marginBottom: 10,
          }}
        >
          {loading ? "Envoi..." : "Envoyer le lien"}
        </button>
        <button
          type="button"
          onClick={goLogin}
          style={{
            width: "100%",
            padding: "9px 12px",
            borderRadius: 8,
            border: "1px solid #d1d5db",
            background: "#fff",
            color: "#374151",
            fontWeight: 600,
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          Retour à la connexion
        </button>
      </form>
    </div>
  );
}
